export default __webpack_public_path__ + "static/media/map-pin.1ff85b78.svg";